import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeIframe'
})
export class SafeIframePipe implements PipeTransform {
  /**
   *
   */
  constructor(private sanitizer: DomSanitizer) {

  }
  transform(url: any, args?: any): any {
    if (!url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }

    const extractedUrl = this.extractValidUrl(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(extractedUrl);
  }

  private extractValidUrl(input: string): string {
    if (!input || typeof input !== 'string') {
      return '';
    }

    let url = input.trim();

    const urlPatterns = [
      /(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|shorts\/|v\/)?[^\s)&]+(&[^\s)]*)*/i,
      /(https?:\/\/)?(www\.)?vimeo\.com\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?dailymotion\.com\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?dai\.ly\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?wistia\.(com|net)\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?vidyard\.com\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?brightcove\.(com|net)\/[^\s)]+/i,
      /(https?:\/\/)?(www\.)?jwplatform\.com\/[^\s)]+/i,
      /(https?:\/\/)?[^\s]+\.(mp4|webm|ogg|m3u8)[^\s)]*/i,
      /(https?:\/\/)?[^\s]+\/embed\/[^\s)]+/i,
      /(https?:\/\/)?[^\s]+\/player\/[^\s)]+/i
    ];

    for (const pattern of urlPatterns) {
      const match = url.match(pattern);
      if (match) {
        let extractedUrl = match[0].trim();
        if (!extractedUrl.startsWith('http://') && !extractedUrl.startsWith('https://')) {
          extractedUrl = 'https://' + extractedUrl;
        }
        return extractedUrl;
      }
    }

    const genericUrlMatch = url.match(/(https?:\/\/)?[^\s)]+/i);
    if (genericUrlMatch) {
      let extractedUrl = genericUrlMatch[0].trim();
      if (!extractedUrl.startsWith('http://') && !extractedUrl.startsWith('https://')) {
        extractedUrl = 'https://' + extractedUrl;
      }
      return extractedUrl;
    }

    return url;
  }

}
